import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { StudentsPerformanceReportFilterForm } from 'src/app/shared/interfaces';

import { Constants } from '../../common';
import { DataWithPagination } from '../../interface';
import { Mapper } from '../mapper/mapper';
import { StudentsPerformanceReport } from '../model';
import { BaseAPI } from './base-api';

@Injectable({
  providedIn: 'root',
})
export class StudentsPerformanceReportApi {
  constructor(private baseAPI: BaseAPI, private mapper: Mapper) {}

  getStudentsPerformanceReport(
    filter: StudentsPerformanceReportFilterForm
  ): Observable<DataWithPagination<StudentsPerformanceReport[]>> {
    return this.baseAPI.post(Constants.GET_STUDENTS_PERFORMANCE_REPORT_API_URL, filter).pipe(
      map((res) => {
        const data: DataWithPagination<StudentsPerformanceReport[]> = {
          data: this.mapper.fromListJson(StudentsPerformanceReport, res.data),
          count: res.count,
        };
        return data;
      })
    );
  }
}
